<script>
import "./style.scss";
import template from "./template.html";
import moment from 'moment';
export default {
    template,
    components: {},
    props: {
        defaultStartDateTime: {
            type: String,
            default: ''
        },
        defaultEndDateTime: {
            type: String,
            default: ''
        },
        dateFormat: {
            type: String,
            default: 'YYYY-MM-DD'
        },
        timeFormat: {
            type: String,
            default: 'HH:mm'
        },
        defaultFormatted: {
            type: String,
            default: 'YYYY-MMM-DD HH:mm'
        }
    },
    methods: {
        getMinDate() {
            return moment().format(this.dateFormat);
        },
        getStartPickerMinDate() {
            if (moment(this.startDateTime).isValid()) {
                return moment(this.startDateTime).format(this.dateFormat);
            }
            return this.getMinDate();
        },
        onStartDateTimePickerHide() {
            // If end date time is less than start date time then
            // set end date time = start date time
            this.endPickerMinDate = this.getStartPickerMinDate();
            if (moment(this.endDateTime).isBefore(moment(this.startDateTime))) {
                this.endDateTime = this.startDateTime;
            }
        },
        onEndDateTimePickerHide() {
            // If end date time is less than start date time then
            // set start date time = end date time
            if (moment(this.endDateTime).isBefore(moment(this.startDateTime))) {
                this.startDateTime = this.endDateTime;
            }
        }
    },
    data () {
        return {
            startDateTime: (this.defaultStartDateTime.length) ? this.defaultStartDateTime : null,
            endDateTime: (this.defaultEndDateTime.length) ? this.defaultEndDateTime: null,
            endPickerMinDate: moment().format(this.dateFormat),
            dateTimeFormat: this.dateFormat + ' ' + this.timeFormat,
        };
    }
}
</script>